<template>
    <div>
        <h3 class="is-size-3">Garantías</h3>
        <p>
            <code>POST {{ host }}/api/firaCollateral</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint tiene dos parámetro:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>id_collateral</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato numerico</li>
                    </ul>
                </li>
                <li>
                    <strong>collateral_type</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Cadena de texto</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe la solicitud en formato JSON:
        </h5>
        <pre>
        <code>
            {
                "id_collateral": 1
            }
        </code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            {
                "id_collateral": 1,
                "collateral_type": "Derechos de cobro incluyendo derechos fiduciarios",
                "minimum_coverage": "0.000",
                "overcollateral": "1.250",
                "min_loss_severity": "0.350"
            }
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>